import styled from "styled-components";
import colors from "../../../../../../../../../styles/colorPalette";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  width: 1300px;
  height: 100%;
  padding-top: 24px;
  box-sizing: border-box;
  background: transparent;
  @media (max-width: 1366px) {
    //font-size: 14px;
  }
`;

export const Text = styled.div`
  font-family: "OpenSansRegular";
  font-size: 22px;
  font-weight: 400;
  color: ${colors.gray6};
  @media (max-width: 1366px) {
    font-size: 14px;
  }
`;
